import { useState } from 'react'
import { toast } from 'react-toastify';
import { Modal } from 'reactstrap';
import { IUser } from 'src/services/types';
import { updateUserVerifiedByAdmin } from 'src/services/users-service';

interface IProps {
    show: boolean;
    onClose: () => void;
    onRefresh: () => void;
    user: IUser;
} 
export const ConfirmValidateModal = ({ show, onClose, user, onRefresh }: IProps) => {

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const onValidate = async () => {
        setError('');
        setLoading(true);
        try {
            const res = await updateUserVerifiedByAdmin(user.id, true);
            if (res.result === 'ok') {
                toast('User validated successfully', { type: 'success'});
                onRefresh();
                onClose();
            } else {
                setError(res.message || 'An error has occurred, please try again later');
            }
            setLoading(false);
        } catch (error) {
            setLoading(false);
            setError('An error has occurred, please try again later');
        }
    }

  return (
    <Modal
        isOpen={show}
        backdrop={"static"}
        id="staticBackdrop"
        size='md'   
    >
           <>
                <div className="modal-body">
                    <div className='col-sm-12 p-3'>
                        <div className='row mb-3 rounded py-2' style={{backgroundColor: '#2ab57d1a'}}>
                            <h4 style={{color: '#000'}}>
                                Confirm validation
                            </h4>
                        </div>
                        <div className='row'>
                            <div className='col-sm-12'>
                                Are you sure you want to validate the user <b>{user?.firstName} {user?.lastName}</b>?
                            </div>
                        </div>
                    </div>
                    {
                        error  && 
                        <div className='col-sm-12 p-3'>
                            <div className='row'>
                                <div className='col-sm-12'>
                                    <div className='alert alert-danger' role='alert'>
                                        {error}
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                </div>

                <div className="modal-footer">
                    <button
                        type="button"
                        className="btn btn-soft-success waves-effect waves-light"
                        onClick={() => onValidate()}
                    >
                        {
                           loading ? 
                            <><i className="fas fa-spinner fa-spin"></i> <span>Validating...</span></>
                            : 'Yes, validate'
                        }
                    </button>
                    <button type="button" className="btn btn-soft-secondary" onClick={onClose}>
                        No, cancel
                    </button>
                </div>
            </>
    </Modal>
  )
}
